var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMizuhoLogo01(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85.943,
    height: 15.487,
    viewBox: "0 0 85.943 15.487",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-142.057 -27.49)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.347,10.018h-1.324c.186.983.33,1.89.441,2.972h1.413c-.15-1-.33-2-.53-2.972",
    transform: "translate(59.89 27.056)",
    fill: "#001f6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.927,12.474h1.144c.125-.7.258-1.709.332-2.481h-1.246c-.061.841-.15,1.752-.231,2.481",
    transform: "translate(60.754 27.051)",
    fill: "#001f6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.228,10.6h1.9V9.152H139.25V7.609h1.517v-1.4H136.5a10.679,10.679,0,0,0,2.128-2.61,30.172,30.172,0,0,1,2.643,2.832V3.962c-.5-.519-1.224-1.149-2.082-1.892h-1.572a7.581,7.581,0,0,1-2.88,3.423V7.487a9.909,9.909,0,0,0,1.326-.9v1.02h1.491V9.152h-2.718V10.6h2.737v4.811c-1,.172-1.966.306-2.73.378v1.725a46.273,46.273,0,0,0,6.412-1.5V14.61c-.576.169-1.284.331-2.025.489Z",
    transform: "translate(59.826 25.425)",
    fill: "#001f6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.366,13.8a9.584,9.584,0,0,0,2.641-3.238h-1.8a7.038,7.038,0,0,1-1.667,2.122,8.521,8.521,0,0,1-1.089-2.892h3.86V2.418h-7.531V17.313a19.565,19.565,0,0,0,3.93-1.052V14.876a16.664,16.664,0,0,1-2.223.527V9.79h.373a9.65,9.65,0,0,0,6.152,7.69V15.657a7.394,7.394,0,0,1-2.641-1.858m.213-8.357h-4.1V3.877h4.1Zm-4.1,1.323h4.1V8.382h-4.1Z",
    transform: "translate(61.163 25.496)",
    fill: "#001f6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.194,5.082h-1.872A11.107,11.107,0,0,1,149.3,9.491v2a11.362,11.362,0,0,0,1.9-1.317V16.66h1.782V8.577a11.5,11.5,0,0,0,2.212-3.5",
    transform: "translate(63.051 26.043)",
    fill: "#001f6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.313,2.07h-1.954a8.321,8.321,0,0,1-3.051,3.678V7.834a11.51,11.51,0,0,0,5.005-5.764",
    transform: "translate(63.052 25.425)",
    fill: "#001f6d"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.44,
    height: 1.634,
    transform: "translate(218.892 28.268)",
    fill: "#001f6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.806,6.263h-9.341V7.9h5.386v6.309c0,.381-.115.527-.547.527h-2.156v1.686h2.8c1.354,0,1.782-.612,1.782-1.814V7.9h2.078Z",
    transform: "translate(64.194 26.285)",
    fill: "#001f6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.461,10.225c-.54-.213-1.26-.476-2-.706a40.317,40.317,0,0,0,.315-5.251h-1.992a31.744,31.744,0,0,1-.215,4.744,28.432,28.432,0,0,0-3.984-.621c.244-1.629.445-3.506.595-5.5h-7.19V4.607h4.983c-.086,1.37-.205,2.61-.36,3.71-4.115.081-5.864,2.356-5.864,4.64a3.042,3.042,0,0,0,3,3.312c2.452,0,3.741-2.166,4.53-6.162a21.977,21.977,0,0,1,4.015.694c-.006.023-.013.049-.018.072a19.892,19.892,0,0,1-2.175,5.842h2.213a22.115,22.115,0,0,0,1.806-5.2c.007-.035.013-.078.021-.118.8.3,1.584.627,2.322.982ZM94.82,14.469c-.746,0-1.188-.722-1.188-1.544,0-1.292.914-2.736,3.684-2.867-.616,3.072-1.541,4.411-2.5,4.411",
    transform: "translate(50.31 25.593)",
    fill: "#001f6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.972,9.134a12.415,12.415,0,0,0-.911-2.688H114.73a11.43,11.43,0,0,1,.909,2.688Z",
    transform: "translate(55.398 26.323)",
    fill: "#001f6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.876,9.134a11.454,11.454,0,0,0-.914-2.688h-1.329a11.8,11.8,0,0,1,.914,2.688Z",
    transform: "translate(55.819 26.323)",
    fill: "#001f6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.712,5.947V4.29h-4.966V2.066h-1.892V4.29H105.54V5.947h8.324V7.234a4.122,4.122,0,0,0-1.725-.335,3.334,3.334,0,0,0-3.455,3.334,3.209,3.209,0,0,0,3.409,3.482,2.887,2.887,0,0,0,2.047-.78c-.318,1.222-1.3,1.98-2.9,2.339a11.424,11.424,0,0,1-2.648.2v1.809a13.978,13.978,0,0,0,3.1-.33c2.889-.693,4.394-2.516,4.394-5.363a6.781,6.781,0,0,0-.348-2.165V5.947ZM112.217,12.1a1.711,1.711,0,0,1-1.725-1.764,1.672,1.672,0,0,1,1.582-1.87A1.734,1.734,0,0,1,113.9,10.13c.1,1.269-1.679,1.972-1.679,1.972",
    transform: "translate(53.363 25.424)",
    fill: "#001f6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.169,10.208c0-2.35.128-4.9.37-7.548h2.005a55.371,55.371,0,0,0-.5,7.45,43.87,43.87,0,0,0,.425,6.65h-2.009c-.186-1.957-.293-4.14-.293-6.553",
    transform: "translate(56.602 25.546)",
    fill: "#001f6d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.2,12.373a11.718,11.718,0,0,0-3.024-1.3c0-.906,0-1.6-.02-2.413h2.61V7h-2.633c-.01-.657-.029-1.416-.039-2.369h2.56V2.983h-9.888V4.634h5.386c.01.57.024,1.365.032,2.369h-5.623V8.656h5.651c.012.627.022,1.315.027,2.036-.184-.019-.375-.034-.566-.039a5.09,5.09,0,0,0-5.005,3.106s1.133,3.118,3.8,3.118c2.645,0,3.712-1.537,3.712-3.409,0-.222,0-.419,0-.615a12.213,12.213,0,0,1,3.024,1.639Zm-4.921.893c.017,1.232-.438,1.991-1.885,1.991-1.391,0-1.849-.762-1.837-1.52s.766-1.691,3.046-1.452c.23.017.447.052.661.088,0,.29,0,.591.015.893",
    transform: "translate(57.353 25.612)",
    fill: "#001f6d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMizuhoLogo01);
export default __webpack_public_path__ + "static/media/mizuho_logo01.4b8868d5f83d3a3fd980f9a79096960b.svg";
export { ForwardRef as ReactComponent };